import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import "./Locations"

export default function Header() {

  return (
    <div className="Head">
      <div className="main">
        <div className="left">
        <a
      href="https://www.facebook.com/share/1EtzuzayQY/?mibextid=qi2Omg"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" ,display:"inline-block" }} // Optional styling
    >
      <img
        src="/assets/facebook-logo-white-11549845815wclpvkfdsb-removebg-preview 1.svg"
        alt="Facebook Logo"
        style={{ height: "28px", width: "28px", verticalAlign: "middle" }}
      />
  </a>   
  <a
      href="https://www.instagram.com/dr.mostafa.el.khosht?igsh=MWp6YnJhZmh1aGZkcw=="
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" ,display:"inline-block" }} // Optional styling
    >
      <img
        src="/assets/1-19361_watercolor-instagram-icon-png-instagram-logo-white-on 1@2x.svg"
        alt="Instagram Logo"
        style={{display:"inline-block", height: "28px", width: "28px", verticalAlign: "middle" }}
      />
    </a>
  <p>
    <a
      href="https://wa.me/201007772199"
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <img
        src="/assets/whatsapp.png"
        alt="WhatsApp Logo"
        style={{ height: "28px", width: "28px", verticalAlign: "middle" }}
      />
    </a>
    </p>
        </div>
        <div className="right">
          <p >01149533395  </p>
          <p style={{fontSize:"44px"}}>-</p>
          <p style={{ paddingRight: "15px" }}>01007772199</p>
          <img src="/assets/OIP__74_-removebg-preview 5@2x.svg" alt="Additional logo" style={{ height: "27.85px", width: "27.81px",  }} />
        </div>
      </div>
    </div>
  );
}
